import { Controller } from "@hotwired/stimulus"

const HOT_BACKGROUND = "linear-gradient(64deg, rgba(225,78,202,.30), rgba(186,84,245,.30))"
const HOT_BORDER = "#e879f9"

export default class extends Controller {
  static targets = ["input", "prompt", "chosen", "filename"]

  connect() {
    this.depth = 0
    this.restBackground = this.element.style.background
    this.restBorder = this.element.style.borderColor
  }

  browse() {
    this.inputTarget.click()
  }

  selected() {
    this.reflect()
  }

  dragenter(event) {
    event.preventDefault()
    this.depth += 1
    this.hot()
  }

  dragover(event) {
    event.preventDefault()
  }

  dragleave(event) {
    event.preventDefault()
    this.depth -= 1
    if (this.depth <= 0) {
      this.depth = 0
      this.cool()
    }
  }

  drop(event) {
    event.preventDefault()
    this.depth = 0
    this.cool()
    const files = event.dataTransfer.files
    if (files && files.length) {
      this.inputTarget.files = files
      this.reflect()
    }
  }

  hot() {
    this.element.style.background = HOT_BACKGROUND
    this.element.style.borderColor = HOT_BORDER
  }

  cool() {
    this.element.style.background = this.restBackground
    this.element.style.borderColor = this.restBorder
  }

  reflect() {
    const file = this.inputTarget.files[0]
    if (!file) return
    this.filenameTarget.textContent = file.name
    this.promptTarget.classList.add("hidden")
    this.chosenTarget.classList.remove("hidden")
    this.restBackground = "linear-gradient(64deg, rgba(0,214,180,.12), rgba(0,214,180,.12))"
    this.restBorder = "rgba(0,214,180,.55)"
    this.cool()
  }
}
